import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import styles from "./style.module.css";
import StoreStandImage from "../../assets/images/store_stand.webp";
import QrCodeImage from "../../assets/images/store_qr_code.png";
import SEOHeading from '../../components/ui/SEOHeading';
import { generateImageAltText } from '../../utils/contentOptimization';

const Catalog = () => {
  return (
    <Container className={`${styles.catalogContainer} py-5`}>
      <Row className="align-items-center mb-5">
        <Col xs={12} md={6} className="mb-4 mb-md-0">
          <Image
            src={StoreStandImage}
            alt={generateImageAltText('catalog', 'Store stand')}
            fluid
            className={styles.catalogImage}
          />
        </Col>
        <Col xs={12} md={6}>
          <SEOHeading level={2} className={styles.catalogTitle}>Kağız Kataloqlar Keçmişdə Qaldı!</SEOHeading>
          <p className={styles.catalogParagraph}>
            Mağazanız üçün təqdim etdiyimiz planşetlər vasitəsilə kağız
            kataloqların istifadəsinə son qoyun! İstənilən operatora uyğun
            rəqəmsal kataloq: Azercell, Bakcell, Nar — fərqi yoxdur! Onlayn
            kataloqla müştərilərinizə daha rahat xidmət göstərin.
          </p>
          <SEOHeading level={3} className={styles.catalogSubtitle}>Üstünlüklərimiz:</SEOHeading>
          <ul className={styles.catalogList}>
            <li className={styles.catalogListItem}>
              <b>Daha az qaralama və kağız israfı:</b> Kağız dəyişmə
              problemlərini aradan qaldırır
            </li>
            <li className={styles.catalogListItem}>
              <b>Limitlərə son:</b> 15 nömrə limiti yoxdur, hər şey sürətli və
              əlçatan
            </li>
            <li className={styles.catalogListItem}>
              <b>Həm onlayn, həm mağazada servis:</b> Nömrələrinizi internetdə
              və mağazanızda asanlıqla təqdim edin.
            </li>
          </ul>
          <SEOHeading level={4} className={styles.catalogHighlight}>
            <b>
              Kağızdan rəqəmsala keçərək həm vaxtınıza, həm də resurslarınıza
              qənaət edin!
            </b>
          </SEOHeading>
        </Col>
      </Row>

      {/* --- SECOND SECTION --- */}
      <Row className="align-items-center">
        {/* Image on the right for large screens */}
        <Col xs={12} md={6} className="order-md-2 mb-4 mb-md-0">
          <Image
            src={QrCodeImage}
            alt={generateImageAltText('catalog', 'QR code')}
            fluid
            className={styles.catalogImage}
          />
        </Col>
        {/* Text on the left for large screens */}
        <Col xs={12} md={6} className="order-md-1">
          <SEOHeading level={2} className={styles.catalogTitle}>QR Kodla Daha Rahat Xidmət!</SEOHeading>
          <p className={styles.catalogParagraph}>
            Müştərilərinizə innovativ həll təqdim edin! Sizə təqdim edəcəyimiz
            <b> QR kod </b> vasitəsilə müştərilər nömrələrinizi öz
            telefonlarında görüntüləyə biləcəklər.
          </p>
          <SEOHeading level={3} className={styles.catalogSubtitle}>Üstünlüklərimiz:</SEOHeading>
          <ul className={styles.catalogList}>
            <li className={styles.catalogListItem}>
              <b>Sıra gözləmədən xidmət:</b> Müştərilər kataloqa dərhal giriş
              əldə edirlər.
            </li>
            <li className={styles.catalogListItem}>
              <b>Təmasdan uzaq, təhlükəsiz təcrübə:</b> Heç kimlə kontaktda
              olmadan və ümumi ekrana toxunmadan rahatlıqla istifadə.
            </li>
            <li className={styles.catalogListItem}>
              <b>Rahatlıq və sürət:</b> Hər zaman, hər yerdə nömrələrinizə asan
              giriş
            </li>
          </ul>
          <SEOHeading level={4} className={styles.catalogHighlight}>
            <b>
              Müasir texnologiya ilə müştərilərinizə həm rahat, həm də
              təhlükəsiz xidmət təqdim edin!
            </b>
          </SEOHeading>
        </Col>
      </Row>
    </Container>
  );
};

export default Catalog;
